import IndexedDBService from '@/services/storage/general/indexeddb-service';
import { CourseBuilderData } from 'course-types';

export type CourseCreatorDraft = {
  courseData: CourseBuilderData;
  currentStep: number;
  completedSteps: Array<boolean>;
};

const COURSE_CREATOR_DRAFT_KEY = 'course-creator-draft';

const CourseCreatorDraftStorageService = {
  async getDraft(): Promise<CourseCreatorDraft | undefined> {
    if (!IndexedDBService.available()) return undefined;
    try {
      const draft = await IndexedDBService.get<CourseCreatorDraft>(COURSE_CREATOR_DRAFT_KEY);
      return draft ?? undefined;
    } catch (e) {
      console.warn('IndexedDB get failed for course creator draft:', e);
      return undefined;
    }
  },

  async setDraft(draft: CourseCreatorDraft): Promise<void> {
    if (!IndexedDBService.available()) return;
    try {
      await IndexedDBService.set<CourseCreatorDraft>(COURSE_CREATOR_DRAFT_KEY, draft);
    } catch (e) {
      console.warn('IndexedDB set failed for course creator draft:', e);
    }
  },

  async resetDraft(): Promise<void> {
    if (!IndexedDBService.available()) return;
    try {
      await IndexedDBService.delete(COURSE_CREATOR_DRAFT_KEY);
    } catch (e) {
      console.warn('IndexedDB delete failed for course creator draft:', e);
    }
  },
};

export default CourseCreatorDraftStorageService;
